/* eslint-disable react/prop-types */
import React from 'react';
import { clsx as cx } from 'clsx';

const imageDiameter = '4.5rem';

export const MenuContainer = ({ children, className, style, ...props }) => (
	<div
		className={cx('flex items-center justify-center', className)}
		style={{ minWidth: '4.5rem', height: '6.5rem', ...style }}
		{...props}
	>
		{children}
	</div>
);

export const Container = ({ children, className, ...props }) => (
	<div className={cx('flex cursor-pointer items-start transition-colors duration-150 hover:bg-accent', className)} {...props}>
		{children}
	</div>
);

export const ImageContainer = ({ children, className, ...props }) => (
	<div className={cx('px-notification-image', className)} {...props}>{children}</div>
);

export const Image = ({ url, className, style, ...props }) => (
	<div
		className={cx('rounded-full bg-white bg-opacity-10 bg-center bg-cover bg-no-repeat', className)}
		style={{ width: imageDiameter, height: imageDiameter, backgroundImage: `url(${url})`, ...style }}
		{...props}
	/>
);

export const NotificationContainer = ({ children, className, ...props }) => (
	<div className={cx('px-notification-content', className)} {...props}>{children}</div>
);

export const NotificationText = ({ children, className, read, ...props }) => (
	<p
		className={cx(
			'flex-1 text-sm',
			read ? 'font-normal text-muted-foreground' : 'font-semibold text-foreground',
			className
		)}
		style={{ margin: '0 1rem', overflowWrap: 'anywhere' }}
		{...props}
	>
		{children}
	</p>
);

export const DurationWrapper = ({ children, className, ...props }) => (
	<span className={cx('whitespace-nowrap font-normal px-notification-duration', className)} {...props}>{children}</span>
);
